// Noto Sans JPが存在しない環境ではこちらを記述することが必要？
// @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&display=swap');

export const StylesForSVGView = `    
    * {
        font-family: \\"Noto Sans JP\\", sans-serif;
    }

    *, *::before, *::after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        -webkit-appearance: none;
    }

    .flex {
        display: flex;
    }

    .shrink-0 {
        flex-shrink: 0;
    }

    .size-full {
        width: 100%;
        height: 100%;
    }

    .w-full {
        width: 100%;
    }

    .min-h-full {
        min-height: 100%;
    }

    .h-full {
        height: 100%;
    }

    .h-auto {
        height: auto;
    }

    .gap-8 {
        gap: 2rem;
    }

    .mt-10 {
        margin-top: 2.5rem;
    }

    .mb-2 {
        margin-bottom: 0.5rem;
    }

    .mb-6 {
        margin-bottom: 1.5rem;
    }

    .mx-6 {
        margin-left: 1.5rem;
        margin-right: 1.5rem;
    }

    .m-2 {
        margin: 0.5rem;
    }

    .ml-\\[10px\\] {
        margin-left: 10px;
    }

    .px-3 {
        padding-left: 0.75rem;
        padding-right: 0.75rem;
    }

    .px-8 {
        padding-left: 2rem;
        padding-right: 2rem;
    }

    .px-16 {
        padding-left: 4rem;
        padding-right: 4rem;
    }

    .px-\\[14px\\] {
        padding-left: 14px;
        padding-right: 14px;
    }

    .px-\\[18px\\] {
        padding-left: 18px;
        padding-right: 18px;
    }

    .py-2 {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .p-2 {
        padding: 0.5rem;
    }

    .p-5 {
        padding: 1.25rem;
    }

    .pt-4 {
        padding-top: 1rem;
    }

    .pb-3 {
        padding-bottom: 0.75rem;
    }

    .pb-8 {
        padding-bottom: 2rem;
    }

    .pb-\\[6px\\] {
        padding-bottom: 6px;
    }

    .pl-\\[6px\\] {
        padding-left: 6px;
    }

    .items-center {
        align-items: center;
    }
        
    .flex-nowrap {
        flex-wrap: nowrap;
    }

    .flex-col {
        flex-direction: column;
    }

    .justify-end {
        justify-content: flex-end;
    }

    .justify-center {
        justify-content: center;
    }

    .text-center {
        text-align: center;
    }

    .grow {
        flex-grow: 1;
    }

    .truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .break-all {
        word-break: break-all;
    }

    .whitespace-break-spaces {
        white-space: break-spaces;
    }

    .whitespace-pre-wrap {
        white-space: pre-wrap;
    }

    .whitespace-nowrap {
        white-space: nowrap;
    }

    .whitespace-pre {
        white-space: pre;
    }

    .inline-block {
        display: inline-block;
    }

    .no-underline {
        text-decoration-line: none;
    }

    .border-none {
        border-style: none;
    }

    .border-2 {
        border-width: 2px;
    }

    .outline-none {
        outline: 2px solid transparent;
        outline-offset: 2px;
    }

    .bg-transparent {
        background-color: transparent;
    }

    .font-bold {
        font-weight: 700;
    }

    .text-white {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    }

    .text-black {
        --tw-text-opacity: 1;
        color: rgb(0 0 0 / var(--tw-text-opacity, 1));
    }

    .bg-\\[\\#EFEFF4\\] {
        --tw-bg-opacity: 1;
        background-color: rgb(239 239 244 / var(--tw-bg-opacity, 1));
    }

    .align-middle {
        vertical-align: middle;
    }

    .fill-neutral-200 {
        fill: #e5e5e5;
    }

    .fill-white {
        fill: #fff;
    }
        
    .fill-gray-300 {
        fill: #e2e8f0;
    }

    .fill-brand {
        fill: #0097A7;
    }

    .stroke-gray-600 {
        stroke: #718096;
    }

    .stroke-gray-700 {
        stroke: #4a5568;
    }

    .text-gray-700 {
        --tw-text-opacity: 1;
        color: rgb(74 85 104 / var(--tw-text-opacity, 1));
    }

    .bg-gray-200 {
        --tw-bg-opacity: 1;
        background-color: rgb(237 242 247 / var(--tw-bg-opacity, 1));
    }

    .text-\\[80px\\] {
        font-size: 80px;
    }

    .text-\\[36px\\] {
        font-size: 36px;
    }

    .text-xl {
        font-size: 1.25rem;
    }

    .text-3xl {
        font-size: 2rem;
    }

    .text-4xl {
        font-size: 2.25rem;
    }

    .text-ellipsis {
        text-overflow: ellipsis;
    }

    .visible {
        visibility: visible;
    }

    .hidden {
        display: none;
    }

    .overflow-visible {
        overflow: visible;
    }

    .overflow-hidden {
        overflow: hidden;
    }

    .hidden-scrollbar {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    .resize-none {
        resize: none;
    }

    .bg-brand {
        --tw-bg-opacity: 1;
        background-color: rgb(0 151 167 / var(--tw-bg-opacity, 1));
    }

    .bg-white {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    }

    .rounded-t-2xl {
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
    }

    .rounded-b-2xl {
        border-bottom-right-radius: 1rem;
        border-bottom-left-radius: 1rem;
    }

    .rounded-2xl {
        border-radius: 1rem;
    }

    .model-comment-body-markdown {
        font-size: 32px !important;
    }

    .markdown-body {
        color-scheme: light;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
        margin: 0;
        color: #1f2328;
        background-color: #ffffff;
        font-size: 16px;
        line-height: 1.5;
        word-wrap: break-word;
    }

    .markdown-body h1, .markdown-body h2, .markdown-body h3, .markdown-body h4, .markdown-body h5, .markdown-body h6 {
        margin-top: 1.5rem;
        margin-bottom: 1rem;
        font-weight: 600;
        line-height: 1.25;
    }

    .markdown-body>*:first-child {
        margin-top: 0 !important;
    }

    .markdown-body>*:last-child {
        margin-bottom: 0 !important;
    }

    .markdown-body p {
        white-space: pre-line;
    }

    .markdown-body h2 {
        font-weight: 600;
        padding-bottom: .3em;
        font-size: 1.5em;
        border-bottom: 1px solid #d1d9e0b3;
    }

    .markdown-body b, .markdown-body strong {
        font-weight: 600;
    }

    .markdown-body ul li {
        list-style: disc;
    }

    .markdown-body ul, .markdown-body ol {
        margin-top: 0;
        margin-bottom: 0;
        padding-left: 2em;
    }

    .markdown-body blockquote {
        margin: 0;
        padding: 0 1em;
        color: #59636e;
        border-left: .25em solid #d1d9e0;
    }

    .markdown-body pre {
        background-color: #edf2f7;
    }

    .markdown-body .highlight pre, .markdown-body pre {
        padding: 1rem;
        overflow: auto;
        font-size: 85%;
        line-height: 1.45;
        color: #1f2328;
        background-color: #f6f8fa;
        border-radius: 6px;
    }

    .bg-white\\/50 {
        background-color: rgb(255 255 255 / 0.5);
    }

    svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
        overflow: visible;
        box-sizing: content-box;
    }

    .svg-inline--fa {
        display: var(--fa-display, inline-block);
        height: 1em;
        overflow: visible;
        vertical-align: -0.125em;
    }

    .object-cover {
        object-fit: cover;
    }

    .bg-neutral-300 {
        --tw-bg-opacity: 1;
        background-color: rgb(212 212 212 / var(--tw-bg-opacity, 1));
    }

    .rounded-full {
        border-radius: 9999px;
    }

    .max-w-none {
        max-width: none;
    }

    .border-solid {
        border-style: solid;
    }

    .border-gray-400 {
        --tw-border-opacity: 1;
        border-color: rgb(203 213 224 / var(--tw-border-opacity, 1));
    }

    .border-white {
        --tw-border-opacity: 1;
        border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
    }

    .border-brand {
        --tw-border-opacity: 1;
        border-color: rgb(0 151 167 / var(--tw-border-opacity, 1));
    }

    .border-t-0 {
        border-top-width: 0px;
    }

    .border-b-6 {
        border-bottom-width: 6px;
    }

    .border-x-6 {
        border-left-width: 6px;
        border-right-width: 6px;
    }

    .text-brand {
        --tw-text-opacity: 1;
        color: rgb(0 151 167 / var(--tw-text-opacity, 1));
    }

    .text-brand-dark {
        --tw-text-opacity: 1;
        color: rgb(0 105 116 / var(--tw-text-opacity, 1));
    }

    .\\[\\&\\>textarea\\]\\:p-2>textarea {
        padding: 0.5rem;
    }

    .\\[\\&\\>textarea\\]\\:bg-white>textarea {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    }

    .\\[\\&\\>textarea\\]\\:border-gray-400>textarea {
        --tw-border-opacity: 1;
        border-color: rgb(203 213 224 / var(--tw-border-opacity, 1));
    }

    .\\[\\&\\>textarea\\]\\:border>textarea {
        border-width: 1px;
    }

    .\\[\\&\\>textarea\\]\\:rounded-lg>textarea {
        border-radius: 0.5rem;
    }

    .\\[\\&\\>textarea\\]\\:w-full>textarea {
        width: 100%;
    }

    .\\[\\&_img\\]\\:w-full img {
        width: 100%;
    }
  `;
